import {InjectionToken} from '@angular/core';
import {AbsoluteDragHandleDirective} from '@shared/absolute-drag/absolute-drag-handle.directive';
import {AbsoluteDragDirective} from '@shared/absolute-drag/absolute-drag.directive';

export const ABSOLUTE_DRAG_HANDLE = new InjectionToken<AbsoluteDragHandleDirective>('AbsoluteDragHandle');
export const ABSOLUTE_DRAG_PARENT = new InjectionToken<AbsoluteDragDirective>('AbsoluteDragParent');
